import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '~env';
import { BaseDataService } from '../../../../../core/storage';
import { FormDefinition } from '../../../../shared/model/company.model';

const useLegalEntityV3 = environment.useLegalEntityV3;
const API_URL_PLATINE = environment.legalEntityV3QueryApi;
@Injectable({
  providedIn: 'root',
})
export class AnnualDeclarationDataService {

  constructor(
    private dataService: BaseDataService<FormDefinition>,
    private http: HttpClient
  ) { }

  getProducts(societeId: string, nbEstblishments: number, memberId: string): any {
    const paymentFormType = 'AN';
    if (!useLegalEntityV3) {
      return this.dataService.get(`payment/${societeId}/${paymentFormType}`, nbEstblishments);
    } else {
      return this.http.get(`${API_URL_PLATINE}/payment/annualDeclaration/${societeId}/${nbEstblishments}/products?memberId=${memberId}`);
    }    
  }

}
